import { useEffect, useRef, useState } from 'react';

/**
 * Custom hook to handle fullscreen functionality for chart components
 * @returns Object containing chartContainerRef, isFullScreen state, and handleFullScreen function
 */
export const useFullscreen = () => {
	const chartContainerRef = useRef<HTMLDivElement>(null);
	const [isFullScreen, setIsFullScreen] = useState(false);

	/**
	 * Toggle fullscreen mode
	 */
	const handleFullScreen = () => {
		if (chartContainerRef.current) {
			if (!document.fullscreenElement) {
				chartContainerRef.current.requestFullscreen();
			} else {
				document.exitFullscreen();
			}
		}
	};

	/**
	 * Listen for fullscreen changes
	 */
	useEffect(() => {
		const handleFullscreenChange = () => {
			setIsFullScreen(!!document.fullscreenElement);
		};

		document.addEventListener('fullscreenchange', handleFullscreenChange);
		
		return () => {
			document.removeEventListener('fullscreenchange', handleFullscreenChange);
		};
	}, []);

	return {
		chartContainerRef,
		isFullScreen,
		handleFullScreen,
	};
};

